"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EqipContact = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class EqipContact extends model_core_1.Contact {
    billingAddress = null;
    yearEstablished = null;
    stateIncorporated = null;
    yearIncorporated = null;
    typeOfEntity = '';
    dnbNumber = '';
    salesContact = {};
    tradeReferences = [];
    insuranceInformation = null;
    constructor(data, olMap, type, idLen) {
        super(data, olMap || index_1.olm);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, model_core_1.Contact);
    }
}
exports.EqipContact = EqipContact;
index_1.olm.contacts = (ref, map) => {
    return new EqipContact(ref, map);
};
